export default "__VITE_ASSET__BotU0ZwG__"